(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/calendar-holder.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/calendar-holder.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useMemo = _React.useMemo,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const DateField = svs.components.DateField;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useLocation = _ReactRouterDOM.useLocation;
const useBranding = svs.components.tipsen.hooks.useBranding;
const regexSportinfoPathnames = svs.components.sportinfo.common.constants.regexSportinfoPathnames;
const _svs$components$tipse = svs.components.tipsen.routeResult,
  useFetchDate = _svs$components$tipse.useFetchDate,
  useCurrentDateDraws = _svs$components$tipse.useCurrentDateDraws;
const uniqueDatesFilter = (draw, i, self) => i === self.findIndex(prev => dateFns.isSameDay(new Date(prev.date), new Date(draw.date)));
const dateIsValid = date => !Number.isNaN(new Date(date).getTime());
const CalendarHolder = () => {
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  const history = useHistory();
  const location = useLocation();
  const _useFetchDate = useFetchDate(),
    _useFetchDate2 = _slicedToArray(_useFetchDate, 3),
    fetchDate = _useFetchDate2[0],
    currentDate = _useFetchDate2[1],
    hasDateParam = _useFetchDate2[2];
  const _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCalendarDate = _useState2[0],
    setSelectedCalendarDate = _useState2[1];
  const _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    initialLatestFinalizedDateObject = _useState4[0],
    setInitialLatestFinalizedDateObject = _useState4[1];
  const isInitialLoad = useRef(true);
  const actualFetchDate = useMemo(() => selectedCalendarDate !== null && selectedCalendarDate !== void 0 ? selectedCalendarDate : fetchDate, [fetchDate, selectedCalendarDate]);
  const _useCurrentDateDraws = useCurrentDateDraws(actualFetchDate.year, actualFetchDate.month, currentDate, hasDateParam),
    _useCurrentDateDraws2 = _slicedToArray(_useCurrentDateDraws, 5),
    currentDateDraws = _useCurrentDateDraws2[0],
    isLoading = _useCurrentDateDraws2[1],
    fetchedDates = _useCurrentDateDraws2[2],
    latestFinalizedDateObj = _useCurrentDateDraws2[3],
    currentDateDrawsError = _useCurrentDateDraws2[4];
  useEffect(() => {
    if ((!dateIsValid(currentDate) || (currentDateDrawsError === null || currentDateDrawsError === void 0 ? void 0 : currentDateDrawsError.status) === 404) && isInitialLoad.current === true) {
      history.replace("/resultat");
      isInitialLoad.current = false;
    }
  }, [currentDate, currentDateDrawsError, isInitialLoad]);
  useEffect(() => {
    if (latestFinalizedDateObj && !initialLatestFinalizedDateObject) {
      setInitialLatestFinalizedDateObject(latestFinalizedDateObj);
    }
  }, [latestFinalizedDateObj]);
  const uniqueDates = useMemo(() => {
    if (fetchedDates) {
      return fetchedDates.filter(uniqueDatesFilter).map(uniqueDate => new Date(uniqueDate.date));
    }
    return undefined;
  }, [fetchedDates]);
  const formatDate = useCallback(_date => {
    if (isLoading) {
      return '';
    }

    const string = dateFns.format(new Date(_date), "EEEE d MMMM yyyy ' (v. 'w')'", {
      locale: dateFns.locales.sv
    });
    return string.charAt(0).toUpperCase() + string.slice(1);
  }, [isLoading]);
  const inputValue = dateObj => ({
    value: dateObj,
    icon: 'menu-down'
  });
  useEffect(() => {
    var _currentDateDraws$;
    if (isInitialLoad.current === true && ((_currentDateDraws$ = currentDateDraws[0]) !== null && _currentDateDraws$ !== void 0 && _currentDateDraws$.date || latestFinalizedDateObj) && location.pathname.split('/').length >= 3) {
      var _currentDateDraws$2;
      const currentDateDrawAsDate = new Date((_currentDateDraws$2 = currentDateDraws[0]) === null || _currentDateDraws$2 === void 0 ? void 0 : _currentDateDraws$2.date);
      const sportinfoTabMatch = location.pathname.match(regexSportinfoPathnames);
      const sportinfoTab = sportinfoTabMatch ? "/".concat(sportinfoTabMatch[0]) : '';
      if (dateIsValid(currentDateDrawAsDate)) {
        isInitialLoad.current = false;
        const dateParam = "".concat(currentDateDrawAsDate.getFullYear(), "-").concat((1 + currentDateDrawAsDate.getMonth()).toString().padStart(2, '0'), "-").concat(currentDateDrawAsDate.getDate().toString().padStart(2, '0'));
        history.push("/resultat/".concat(dateParam).concat(sportinfoTab).concat(location.search));
      } else if (dateIsValid(latestFinalizedDateObj)) {
        isInitialLoad.current = false;
        const dateParam = "".concat(latestFinalizedDateObj.getFullYear(), "-").concat((1 + latestFinalizedDateObj.getMonth()).toString().padStart(2, '0'), "-").concat(latestFinalizedDateObj.getDate().toString().padStart(2, '0'));
        history.push("/resultat/".concat(dateParam).concat(sportinfoTab).concat(location.search));
      }
    }
  }, [latestFinalizedDateObj, currentDateDraws]);
  const inputProps = useMemo(() => {
    if (hasDateParam) {
      return inputValue(new Date(fetchDate.year, parseInt(fetchDate.month, 10) - 1, fetchDate.day));
    }
    if (dateFns.isSameDay(initialLatestFinalizedDateObject, latestFinalizedDateObj)) {
      return inputValue(latestFinalizedDateObj);
    }
    return inputValue(initialLatestFinalizedDateObject);
  }, [fetchDate, hasDateParam, latestFinalizedDateObj, initialLatestFinalizedDateObject]);
  const onChange = useCallback(selectedDate => {
    const month = selectedDate.month + 1;
    history.replace("/resultat/".concat(selectedDate.year, "-").concat(month.toString().padStart(2, '0'), "-").concat(selectedDate.day.toString().padStart(2, '0')));
  }, [history]);
  const onViewChange = useCallback(view => {
    setSelectedCalendarDate({
      year: view.year,
      month: view.month + 1
    });
  }, []);
  const pickadateOptions = useMemo(() => ({
    isTodayOrTomorrow: false,
    klass: {
      navPrev: 'calendar-left-arrow icon-default icon-menu-left js-previous pointer',
      month: 'inline-block month-label',
      year: 'inline-block year-label',
      buttonClose: 'btn btn-100 btn-default',
      navNext: 'calendar-right-arrow icon-default icon-menu-right js-next pointer',
      opened: 'picker--opened',
      picker: 'picker date-picker-default'
    },
    openCloseInput: true,
    disable: [true].concat(uniqueDates) 
  }), [uniqueDates]);
  if (!(inputProps !== null && inputProps !== void 0 && inputProps.value)) {
    return 'Laddar...';
  }
  return React.createElement("div", {
    className: "datefield inline-block datefield--".concat(productBranding)
  }, React.createElement(DateField, {
    format: formatDate,
    inputProps: inputProps,
    onChange: onChange,
    onViewChange: onViewChange,
    pickadateOptions: pickadateOptions
  }));
};
setGlobal('svs.components.tipsen.routeResult.CalendarHolder', CalendarHolder);

 })(window);